var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "doctor-visits"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Návštěvy")]), _vm._v(" " + _vm._s(_vm.print_date) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "data-testid": "doctor-visits-today"
    },
    on: {
      "click": function($event) {
        _vm.selectToday()
      }
    }
  }, [_vm._v("dnes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "doctor-visits-tomorrow"
    },
    on: {
      "click": function($event) {
        _vm.selectTomorrow()
      }
    }
  }, [_vm._v("zítra")])]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "validFrom",
      "input-class": "datapickerInput"
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    on: {
      "click": function($event) {
        _vm.getDoctorsDayVisits()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-left"
  }, [(_vm.doctors.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plannedFor),
      expression: "plannedFor"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "doctor-visits-doctor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.plannedFor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("všichni doktoři")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-left"
  }, [(_vm.branches.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedBranch),
      expression: "selectedBranch"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "branchHelp",
      "id": "branch",
      "placeholder": "vybrat pobočku",
      "data-testid": "doctor-visits-branch"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedBranch = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("obě pobočky")]), _vm._v(" "), _vm._l((_vm.branches), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.label))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-right"
  }, [(_vm.showRemainingVisitsToo) ? [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    on: {
      "click": _vm.showHideRemainingVisits
    }
  }, [_vm._v("filtrovat dle důvodu")])] : [_c('multiselect', {
    staticClass: "trolo",
    attrs: {
      "id": "medics",
      "props": "options",
      "options": _vm.visitPurposes,
      "track-by": "id",
      "label": "purpose",
      "placeholder": "důvod návštěvy",
      "multiple": true,
      "limit": 1,
      "limit-text": _vm.limitText,
      "option-height": 104,
      "open-direction": "down",
      "show-labels": false,
      "TagPlaceholder": "",
      "selectLabel": ""
    },
    on: {
      "input": _vm.selectVisitPurposesId
    },
    model: {
      value: (_vm.selectedVisitPurposes),
      callback: function($$v) {
        _vm.selectedVisitPurposes = $$v
      },
      expression: "selectedVisitPurposes"
    }
  })]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 text-left"
  }, [(_vm.selectedStates.indexOf('scheduled') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('scheduled')
      }
    }
  }, [_vm._v("plánovaní")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('scheduled'), 1)
      }
    }
  }, [_vm._v("plánovaní")]), _vm._v(" "), (_vm.selectedStates.indexOf('arrived') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "arrived"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('arrived')
      }
    }
  }, [_vm._v("v čekárně")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "arrived"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('arrived'), 1)
      }
    }
  }, [_vm._v("v čekárně")]), _vm._v(" "), (_vm.selectedStates.indexOf('elaborated') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('elaborated')
      }
    }
  }, [_vm._v("rozpracovaní")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('elaborated'), 1)
      }
    }
  }, [_vm._v("rozpracovaní")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("splněno")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("splněno")]), _vm._v(" "), (_vm.selectedStates.indexOf('failed') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('failed') + _vm.selectedStates.push('excused')
      }
    }
  }, [_vm._v("nepřišel")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('failed'), 1) + _vm.selectedStates.splice(_vm.selectedStates.indexOf('excused'), 1)
      }
    }
  }, [_vm._v("nepřišel")]), _vm._v(" "), (_vm.selectedStates.indexOf('canceled') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('canceled')
      }
    }
  }, [_vm._v("zrušeno")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('canceled'), 1)
      }
    }
  }, [_vm._v("zrušeno")])])])]), _vm._v(" "), (_vm.visits.length > 0) ? [(_vm.filteredVisits.length > 0) ? _c('div', {
    staticClass: "card-body pl-0 pr-0"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_vm._l((_vm.filteredVisits), function(visit, index) {
    return [_c('tr', {
      attrs: {
        "data-testid": 'doctor-visit-' + visit.id
      }
    }, [_c('td', {
      staticClass: "align-middle",
      style: ({
        borderLeft: (visit.visit_purpose.color !== '' ? '5px solid #' + visit.visit_purpose.color : '5px solid transparent')
      }),
      attrs: {
        "rowspan": "2"
      }
    }, [_c('visit-change-state', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id
      },
      on: {
        "update": _vm.getDoctorsDayVisits
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(visit.hasData) ? [_c('button', {
      staticClass: "btn btn-sm btn_extra_small btn-primary",
      attrs: {
        "data-testid": 'doctor-visit-detail-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.showHideVisitDetail(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'ShowVisit',
          params: {
            clientid: visit.client.id,
            visitid: visit.id
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(visit.date) + " od " + _vm._s(visit.timeFrom) + " do " + _vm._s(visit.timeTo) + " (" + _vm._s(_vm._f("minutesToCsTime")(visit.duration * 5)) + ")\n                            ")])], 2), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "align-middle pr-2",
      attrs: {
        "colspan": "2"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ShowVisit',
          params: {
            clientid: visit.client.id,
            visitid: visit.id
          }
        }
      }
    }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))])]), _vm._v(" "), (_vm.editingVisitId === visit.id) ? [_c('label', {
      attrs: {
        "for": "note"
      }
    }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('form', {
      staticClass: "form-inline",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.putVisit(visit)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editingVisit.note),
        expression: "editingVisit.note"
      }],
      staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "noteHelp",
        "id": "note",
        "data-testid": 'doctor-visit-note-' + visit.id
      },
      domProps: {
        "value": (_vm.editingVisit.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editingVisit.note = $event.target.value
        }
      }
    }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "data-testid": 'doctor-visit-save-' + visit.id
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])])] : [_c('button', {
      staticClass: "btn btn-sm btn-link text-secondary",
      attrs: {
        "data-testid": 'doctor-visit-edit-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.editVisit(visit.note, visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "no-top-border",
      attrs: {
        "colspan": "3"
      }
    }, [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: visit.client.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(visit.client.full_name))]), _vm._v(" - "), (visit.client.insurance_number) ? _c('span', [_vm._v("ČP: "), _c('b', [_vm._v(_vm._s(visit.client.insurance_number))])]) : _c('span', [_vm._v("RČ: "), _c('b', [_vm._v(_vm._s(visit.client.p_i_n))])]), _vm._v(" "), (visit.client.health_insurance && visit.client.health_insurance.code === '---') ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v("SAMOPLÁTCE")]) : (visit.client.health_insurance) ? _c('span', {
      staticClass: "badge badge-secondary"
    }, [_vm._v(_vm._s(visit.client.health_insurance.code))]) : _c('span', {
      staticClass: "badge badge-danger"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybí zdrav. pojišťovna")]), _vm._v(" "), (visit.client.membership) ? [(_vm.membershipExpiresSoon(visit.client.membership) && (visit.client.membership.has_next_membership === false)) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'končí již: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
          placement: 'bottom-center',
          classes: ['danger']
        }),
        expression: "{\n                                  content: 'končí již: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.paid === false ? '<br> <span class=\\'text-danger\\'>klient nezaplatil</span>' : ''),\n                                  placement: 'bottom-center',\n                                  classes: ['danger']}"
      }],
      staticClass: "badge badge-primary",
      class: [visit.client.membership.name === 'VIP' ? 'badge-danger' : (visit.client.membership.name === 'PREVENCE PLUS' ? 'badge-success' : ''), 'badge-primary']
    }, [_c('i', {
      staticClass: "fa fa-warning text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), (visit.client.membership.paid === false) ? _c('i', {
      staticClass: "fa fa-dollar text-danger"
    }) : _vm._e(), _vm._v("\n                                    " + _vm._s(visit.client.membership.name) + "\n                                  "), (visit.client.membership.name === 'VIP') ? [_c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    })] : _vm._e()], 2) : _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'platný do: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (visit.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                  content: 'platný do: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (visit.client.membership.paid === false ? '<br> <span class=\\'text-danger\\'>klient nezaplatil</span>' : ''),\n                                  placement: 'bottom-center',\n                                  classes: ['info']}"
      }],
      staticClass: "badge",
      class: [visit.client.membership.name === 'VIP' ? 'badge-danger' : (visit.client.membership.name === 'PREVENCE PLUS' ? 'badge-success' : ''), 'badge-primary']
    }, [(visit.client.membership.paid === false) ? _c('i', {
      staticClass: "fa fa-dollar text-danger"
    }) : _vm._e(), _vm._v("\n                                    " + _vm._s(visit.client.membership.name) + "\n                                  "), (visit.client.membership.name === 'VIP') ? [_c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    })] : _vm._e()], 2)] : (visit.client.last_membership) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'skončil: <b>' + visit.client.last_membership.valid_to + '</b>',
          placement: 'bottom-center',
          classes: ['secondary']
        }),
        expression: "{\n                                  content: 'skončil: <b>' + visit.client.last_membership.valid_to + '</b>',\n                                  placement: 'bottom-center',\n                                  classes: ['secondary']}"
      }],
      staticClass: "badge badge-secondary"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" poslední: " + _vm._s(visit.client.last_membership.name))]) : _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" nemá program")]), _vm._v(" "), (visit.client.missing_data) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybějící údaje")]) : _vm._e(), _vm._v(" "), (visit.client.missing_contact) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybějící kontakty")]) : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "no-top-border text-right pr-2",
      attrs: {
        "colspan": "1"
      }
    }, [_vm._v("\n                            " + _vm._s(visit.planned_for.fullname) + "\n                            "), _c('visit-change-doctor', {
      attrs: {
        "doctors": _vm.doctors,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id
      },
      on: {
        "update": _vm.getDoctorsDayVisits
      }
    }), _vm._v(" "), (visit.planned_by && visit.planned_at) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne <b>' + visit.planned_at + '</b>',
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                  content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne <b>' + visit.planned_at + '</b>',\n                                  placement: 'bottom-center',\n                                  classes: ['info']}"
      }],
      staticClass: "text-info fa fa-lg fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()], 1)]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('tr', {
      attrs: {
        "data-testid": 'doctor-visit-details-' + visit.id
      }
    }, [_c('td', {
      staticClass: "border-top-0"
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [(visit.presenting_complaint) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v(_vm._s(visit.presenting_complaint.anamnesis_type.name))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.presenting_complaint.text)
      }
    })]) : (visit.medical_report) ? _c('div', {}, [_c('h6', [_vm._v("Výsledná zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "pr-2",
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                            " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                        ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                            ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                            ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(0, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Recepty")]), _vm._v(" "), _c('div', [(visit.prescriptions.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.prescriptions), function(p) {
      return [_vm._l((p.medicaments), function(m, index) {
        return [(p.status === 'PREPARED' || p.type === 'printed') ? _c('tr', {
          staticClass: "row m-0"
        }, [(index === 0) ? _c('td', {
          staticClass: "text-center col-md-1"
        }, [(p.type === 'printed') ? _c('span', [_c('i', {
          staticClass: "fa fa-print",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e(), _vm._v(" "), (p.type === 'electronic') ? _c('span', {
          staticClass: "font-weight-bold"
        }, [_c('span', {
          staticClass: "green"
        }, [_vm._v("E")]), _vm._v("R.\n                                                            ")]) : _vm._e()]) : _c('td', {
          staticClass: "col-md-1 empty_cell"
        }), _vm._v(" "), _c('td', {
          staticClass: "align-middle col-md-7"
        }, [_vm._v("\n                                                          " + _vm._s(m.medicine ? m.medicine.label : '') + "\n                                                          " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + "\n                                                        ")]), _vm._v(" "), _c('td', {
          staticClass: "align-middle col-md-1"
        }, [_vm._v("\n                                                            " + _vm._s(m.amount) + "\n                                                        ")]), _vm._v(" "), _c('td', {
          staticClass: "align-middle col-md-2"
        }, [_vm._v("\n                                                            " + _vm._s(m.dosage) + "\n                                                        ")]), _vm._v(" "), (index === 0) ? _c('td', {
          staticClass: "align-middle col-md-1"
        }, [(p.patient_notification_type === 'SMS') ? _c('i', {
          staticClass: "fa fa-mobile-phone",
          attrs: {
            "aria-hidden": "true"
          }
        }) : (p.patient_notification_type === 'EMAIL') ? _c('i', {
          staticClass: "fa fa-envelope-o",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _c('i', {
          staticClass: "fa fa-ban text-danger",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _c('td', {
          staticClass: "col-md-1 empty_cell"
        })]) : _vm._e()]
      })]
    })], 2)])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])])]) : _vm._e()]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.remainingVisits.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-text"
  }, [_vm._v("... a " + _vm._s(_vm.remainingVisits.length) + " " + _vm._s(_vm.remainingVisits.length > 4 ? 'vyfiltrovaných' : 'vyfiltrovaný') + "\n                "), _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "data-testid": "doctor-visits-show-filtered"
    },
    on: {
      "click": _vm.showHideRemainingVisits
    }
  }, [_vm._v("zobrazit také")])])]) : _vm._e()] : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)])], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5de81a6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeDoctor/components/Visits.vue
// module id = 388
// module chunks = 0